import { Instant } from '@js-joda/core';
import { useSignals } from '@preact/signals-react/runtime';
import { useQuery } from '@tanstack/react-query';
import { EmptyArray } from '@thinkalpha/common/util/iterators.js';
import { useContainer } from 'src/features/ioc';
import { getIndicatorViewModels } from 'src/lib/dictionary/dictionary';
import type { RootState } from 'src/store';
import { useSelector } from 'src/store/hooks';

const selectUser = (state: RootState) => state.auth?.masqUser ?? state.auth?.user;
export const useUser = () => {
    useSignals();
    const legacyUser = useSelector(selectUser);
    return useContainer().getOptional('CurrentUserModel')?.user.value ?? legacyUser;
};

export const selectAccessToken = (state: RootState) => state.auth?.masqAccessToken ?? state.auth?.accessToken;
export const useAccessToken = () => {
    useSignals();
    const masqToken = useSelector((state: RootState) => state.auth?.masqAccessToken);
    const session = useContainer().get('SessionService');
    const token = session.accessToken.value;
    const state = session.state.value;
    const expires =
        (state.phase === 'authenticated' || state.phase === 'refreshing') && typeof state.claims.exp === 'number'
            ? Instant.ofEpochSecond(state.claims.exp)
            : undefined;

    return masqToken ?? (token ? { token, expires } : null);
};

export const useGetIndicators = () => {
    const { data } = useQuery({
        queryKey: ['indicators'],
        queryFn: () => getIndicatorViewModels(),
        placeholderData: EmptyArray,
    });

    // ToDo: Figure out serialization issue causing indicators to serialize to []
    if (!Array.isArray(data)) {
        return [];
    }

    return data ?? EmptyArray;
};
